(
    function(){
angular.module('ui2.0Directives')
		.directive('attributeTable2',attributeTable2)
		.directive('scrollElem',scrollElem)
		.directive('draggableElem',draggableElem)
		.directive('showinpopup2',showinpopup2)
        .directive('bulkActionPopup',bulkactionpopup)
		.directive('treeViewNew',treeViewNew)
		.directive("ajaxAutocompleteNew",ajaxAutocompleteNew)
        .directive("dragAndDropFiles",dragAndDropFiles)
        .directive("multipleSelect",multipleSelect)
        .directive("autoExpandTextarea",autoExpandTextarea)
        .directive("contractToCdrTab", contractToCdrTab)
        .directive("contractDocUpload", contractDocUpload);

/* *** function definition of attributeTable2 directive ****/
function attributeTable2($rootScope,$showPageService) {
    return {
        restrict: 'A',
        templateUrl: $rootScope.createHtmlUrl("attributeTable.html"),
        scope:true,
        link: function ($scope, element, attrs) {
        	var valueEndField = "values",//contains the endd Value Node
        	valuePrefix = "",//contains the path before the end Node
        	valueField = ((valuePrefix.trim().length > 0)?valuePrefix + ".":"") + valueEndField;//this the the complete value path
            $scope.fieldData =  element.data("fieldData");
            $scope.fieldLabel  = angular.copy($scope.fieldData.columnLabel);
            $scope.fieldInfo = angular.copy($scope.fieldData.properties.info);
            $scope.dataModel = $showPageService.getModelfromString.call($scope,"data." + ($scope.fieldData.model || "") + $scope.fieldData.name +  "." + valueField);
        }
    }
}
/* ****** End of attributeTable2 function *************/

/* *** function definition of scrollElem directive ****/
function scrollElem($timeout,showPage2DataTransformationService){
	return {
        restrict: 'A',        
        scope:true,
        link: function ($scope, element, attrs) {
        	let elmnt = element[0];
        	var showExpandAllInHeader ;
        	elmnt.addEventListener("scroll",scrollBehaviour);
            //elmnt.addEventListener("scroll",_.throttle(scrollBehaviour, 250, { leading: true, trailing: true}));
        	function scrollBehaviour(){
                if(attrs.scrollParentInfo == 'commentSec'){
                    if(element.closest('.dragble-area').length && element.find('.filter').length){

                        if( element.closest('.dragble-area').offset().top - element.find('.filter').offset().top > -1){
                            element.find('.filter').parent().addClass('staticPos');
                        }
                        if( (element.closest('.dragble-area').offset().top == element.find('.filter').offset().top) && angular.element('.showCommentBoxButton').is(':visible')){
                            if(angular.element(elmnt).scrollTop() < 15){
                                element.find('.filter').parent().removeClass('staticPos');
                            }
                            return;
                        }else{
                            if(angular.element(elmnt).scrollTop() - element.find('.filter').offset().top < 0){
                                element.find('.filter').parent().removeClass('staticPos');
                            }
                        }
                    }
                }else if(angular.element('#ui-datepicker-div').is(':visible')){
        			angular.element('.hasDatepicker').datetimepicker('hide');
        			angular.element('.hasDatepicker').blur();
        		}
        		if(attrs.showExpandAll){
        		    if(angular.element('.jx-nwfBtn').length && angular.element('.jx-toggleAllGroupsInform').length) {
                        if ((angular.element('.jx-nwfBtn').offset().top + angular.element('.jx-nwfBtn').outerHeight()) >(angular.element('.jx-toggleAllGroupsInform').offset().top+angular.element('.jx-toggleAllGroupsInform').outerHeight())) {
                            showExpandAllInHeader = true;
                        } else {
                            showExpandAllInHeader = false;
                        }
                        $scope.$emit('updateExpandAll', showExpandAllInHeader);
                    }

                }
        	}
        	
        }
    }
}
/* ****** End of scrollElem function *************/

/* *** function definition of draggableElem directive ****/
function draggableElem($document) {
  return {
    link: function(scope, element, attr) {
    	let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    	let elmnt = element[0];
        let elem = element.find('#jx-docTitle').length ? element.find('#jx-docTitle')[0] : element[0];
	    elem.onmousedown = dragMouseDown;
	   
       let doctreePosInfo = sessionStorage.getItem('doctreePosition');
       if(doctreePosInfo){
    		doctreePosInfo = JSON.parse(doctreePosInfo);
			if(doctreePosInfo.hasOwnProperty('top') && doctreePosInfo.hasOwnProperty('left')){
    			elmnt.style.top = doctreePosInfo.top+'px';
    			elmnt.style['inset-inline-start'] = doctreePosInfo.left+'px';
    		}
    	}
    		
	   function dragMouseDown(e) {
	     e = e || window.event;
	     // get the mouse cursor position at startup:
	     pos3 = e.clientX;
	     pos4 = e.clientY;
	     document.onmouseup = closeDragElement;
	     // call a function whenever the cursor moves:
	     document.onmousemove = elementDrag;
	   }

	   function elementDrag(e) {
	     e = e || window.event;
	     // calculate the new cursor position:
	     pos1 = pos3 - e.clientX;
	     pos2 = pos4 - e.clientY;
	     pos3 = e.clientX;
	     pos4 = e.clientY;	     
	     let bottomOffset = (document.getElementById('data-ng-app')?.offsetHeight || 0) - (elmnt?.offsetTop || 0) - (elmnt?.offsetHeight || 0),
	     	 rightoffset = (document.getElementById('data-ng-app')?.offsetWidth || 0) - (elmnt?.offsetLeft || 0) - (elmnt?.offsetWidth || 0),
	     	 leftOffset = rightoffset > -1 ? elmnt.offsetLeft - pos1 : (document.getElementById('data-ng-app')?.offsetWidth || 0)-(elmnt?.offsetWidth || 0),
	     	 topOffset = bottomOffset > -1 ? elmnt.offsetTop - pos2 : (document.getElementById('data-ng-app')?.offsetHeight || 0)-(elmnt?.offsetHeight || 0)-21;
	     // set the element's new position:
           if(topOffset > -1 && leftOffset > -1 ){
               elmnt.style.top = topOffset + "px";
               elmnt.style['inset-inline-start'] = leftOffset + "px";
               if(sessionStorage.getItem('doctreePosition')){
            	   let tempdata = JSON.parse(sessionStorage.getItem('doctreePosition'));
            	   tempdata.top = topOffset;
            	   tempdata.left = leftOffset;
            	   sessionStorage.setItem('doctreePosition',JSON.stringify(tempdata));
               }
           }

	   }

	   function closeDragElement() {
	     /* stop moving when mouse button is released:*/
	     document.onmouseup = null;
	     document.onmousemove = null;
	   }

    	
    }
  }; 
}
/* ****** End of draggableElem function *************/

/* *** function definition of showinpopup2 directive ****/
function showinpopup2($timeout, $modal, $rootScope,showPage2DataTransformationService,showPageService,$route,$window){
    return {
        restrict:'AE',
        template : '',
        link: function(scope, element, attrs){
            function removeDialogContainer(){
                window.isExceptionalPage && $window.location.reload();
                scope.showBulkEditDialog && (scope.showBulkEditDialog.visible = false);
                scope.showCreateDialog && (scope.showCreateDialog.visible = false);
                scope.showBulkActionDialog && (scope.showBulkActionDialog.visible = false);
                scope.showInvoiceUploadDialog && (scope.showInvoiceUploadDialog.visible = false);
                scope.showDelegationPopup && (scope.showDelegationPopup.visible= false);
                if(_.get(scope.showBulkAmendmentDialog,"visible")) {
                    scope.applyListingPageScope();
                    scope.showBulkAmendmentDialog.visible = false;
                    $rootScope.templateSuggestionPage = false;
                    // Clear listing selection and refresh table on close/cancel
                    if (typeof BU !== "undefined" && BU.resetSelectionState) {
                        BU.resetSelectionState(true);
                    } else {
                        checkedVal = [];
                        unCheckedVal = [];
                        if ($("#cr").length) {
                            $("#cr").dataTable().fnDraw();
                        }
                    }
                }

                if(scope.showBulkEditDialog || scope.showCreateDialog){
                    checkedVal = [];
                    if($rootScope.isMiraPageActive) {
                        window.startLoader();
                    }
                    $("#cr").dataTable().fnDraw();
                }
                delete $rootScope.externalContract;
                $rootScope.myModelInstance = null;
            }
            var size = attrs.size ? attrs.size : "lg";
            var templateUrl = "";
            var  additionalClass = size == "sm"?"smallCommentForm":"";
            if(Boolean(attrs.showheader) == true){
                //templateUrl = $rootScope.createHtmlUrl("ui2.0/showViewWithHeader.html");
                //templateUrl = $rootScope.createHtmlUrl("ui2.0/showViewTemplate.html");
                additionalClass += " global_create";
                scope.titlebartext = attrs.titlebartext;
            }

            templateUrl = $rootScope.createHtmlUrl("ui2.0/showViewTemplate.html");
            if(attrs.invoicebox == "true") {
                templateUrl = $rootScope.createHtmlUrl("ui2.0/invoiceUploadView.html");
            }
            if(attrs.commentBox=="true"){
                templateUrl = $rootScope.createHtmlUrl("ui2.0/commentBoxTemplate.html");
            }
            if(attrs.delegationPopup == "true"){
                additionalClass += " delegation_create";
                templateUrl = $rootScope.createHtmlUrl("ui2.0/createDelegationTemplate.html");
            }
            if(attrs.bulkamendment=="true"){
                templateUrl = $rootScope.createHtmlUrl("ui2.0/bulkAmendment.html");
            }
            if($rootScope.externalContract) {
                size = "sm";
                additionalClass += " create_external_contact_popup";
                const ajaxcalloading = document.getElementsByClassName('always_visible')[0];
                ajaxcalloading?.classList.remove('always_visible');
            }
            if(scope.fromSupplierDropdown) {
                size = "sm";
                additionalClass += " create_external_supplier_popup";
                let interval = setInterval(() => {
                    const elm = $('.create_external_supplier_popup .sirion_switch .sirion_checkbox');
                    if(elm.length) {
                        clearInterval(interval);
                        elm.click();
                    }
                },50)
            }
            $timeout(function() {

                $rootScope.myModelInstance = $modal.open({
                    //templateUrl: $rootScope.createHtmlUrl("ui2.0/commonFormTemplate2.html"),
                    templateUrl: templateUrl,
                    modal:true,
                    size: size,
                    backdrop:"static",
                    keyboard  : false,
                    scope:scope,
                    windowClass: "clonepopup " + additionalClass
                });
                $timeout(function(){
                    if($("#ajaxcalloading").is(":visible")){
                        stopLoader();
                    }
                },2000);
                if($rootScope.modalInstances){
                    $rootScope.modalInstances.push($rootScope.myModelInstance);
                } else {
                    $rootScope.modalInstances = [];
                    $rootScope.modalInstances.push($rootScope.myModelInstance);
                }
                scope.close = function () {
                    if(scope.isCdrCreateExternalContactFlow && scope.isCdrCreateExternalContactFlow()) {
                        scope._ecModalCloseOwnedByCancel = true;
                        window.__ecOwnedModalClose = true;
                        scope.handleCdrCreateExternalContactCancel();
                        return;
                    }
                    if(scope.fromSupplierDropdown) {
                        window.sarc.channelBroadcast("reactDynamicForms", {
                            actionType: "newlyCreatedSupplierDetails",
                            payload: []
                        }, `dfSubscriptions_${scope.globalData.dynamicFormId}`);
                        setTimeout(() => {
                            scope.applyBasePageJson();
                        }, 300)
                    }
                    $rootScope.myModelInstance.close();
                    if($rootScope.bulkedit && $rootScope.isMiraPageActive){
                        window.SirionUtils.resetDataGridTableSelectedCheckbox();
                    }
                    if(scope.openFromShareWithConuterParty){
                        scope.dataOfnewExtarnalContract = null;
                        const wfId = scope.dataOfShareCountyPartyModal?.wfId;
                        const requestId = scope.dataOfShareCountyPartyModal?.requestId;
                        scope.callShareWithCounterParty("close",wfId,requestId,scope.openFromShareWithConuterParty);
                    }

                };

                $rootScope.myModelInstance.closed.then(
                    function() {
                        removeDialogContainer();
                        var ecOwnedClose = !!(scope._ecModalCloseOwnedByCancel || window.__ecOwnedModalClose);
                        var isCreateLikePage = scope.pageType == 'create' || scope.pageType == 'clone' || scope.pageType == 'globalCreate';
                        if (ecOwnedClose) {
                            scope._ecModalCloseOwnedByCancel = false;
                            delete window.__ecOwnedModalClose;
                            delete window.__ecCdrCreateFlowActive;
                            return;
                        }
                        // Avoid listing jump via workspace list click on create popups.
                        if (!isCreateLikePage) {
                            commonUtil.clickFirstListElement(scope);
                        }
                        if(isCreateLikePage){
                            scope.applyBasePageJson();
                        }
                    },
                    function() {
                        removeDialogContainer();
                        var ecOwnedClose = !!(scope._ecModalCloseOwnedByCancel || window.__ecOwnedModalClose);
                        if (ecOwnedClose) {
                            scope._ecModalCloseOwnedByCancel = false;
                            delete window.__ecOwnedModalClose;
                            delete window.__ecCdrCreateFlowActive;
                            return;
                        }
                        if(scope.pageType == 'create' || scope.pageType=='clone'){
                            scope.applyBasePageJson();
                        }
                    }
                );
                $rootScope.myModelInstance.rendered.then(function(){
                    showPageService.preventLabelClick();
                    resizeInnerForm();
                    resizeClauseList()
                });
                //SIR-182367
                /*$rootScope.myModelInstance.rendered.then(function(){
                    if(scope.pageType == 'create' || scope.pageType == 'clone'){
                        var formFieldGroups = showPage2DataTransformationService.createGroupOfFields(scope.layout.fields[_.findIndex(scope.layout.fields,function(o){return o.type=="basic"})].fields);
                        showPage2DataTransformationService.hideNonReqFields(formFieldGroups);
                    }
                });*/
            }, 0);
        }
    };
}
/* ****** End of showinpopup2 function *************/

function bulkactionpopup($timeout, $modal, $rootScope ){
    return {
        restrict:'AE',
        template : '',
        link: function(scope, element, attrs){
            $timeout(function() {
                var  additionalClass = "";
                $rootScope.myModelInstance = $modal.open({
                    templateUrl: $rootScope.createHtmlUrl("ui2.0/commonFormTemplate2.html"),
                    modal:true,
                    size: "md",
                    keyboard:false,
                    backdrop:"static",
                    windowClass: "clonepopup " + additionalClass
                });
                if($rootScope.modalInstances){
                    $rootScope.modalInstances.push($rootScope.myModelInstance);
                } else {
                    $rootScope.modalInstances = [];
                    $rootScope.modalInstances.push($rootScope.myModelInstance);
                }
            }, 0);

        }
    };
}


/* *** function definition of treeViewNew directive ****/
function treeViewNew($rootScope) {
    return {
        restrict: "C",
        templateUrl: $rootScope.createHtmlUrl("contractTemplateTreeView.html"),
        scope: {
            'treeData': '='
        },
        link: function (scope, element, attr, ctrl) {
            scope.showChildContracts = function (e) {
                if (angular.element(e.target).closest('li').hasClass('active')) {
                    angular.element('.jx-contractTempLi').removeClass('active');
                } else {
                    angular.element('.jx-contractTempLi').removeClass('active');
                    angular.element(e.target).closest('li').addClass('active');
                }

            };
        }
    }
}
/* ****** End of treeViewNew function *************/

function multipleSelect($rootScope,$timeout) {
    return {
        restrict: "CAE",
        templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/multipleSelectTemplate.html"),
        scope:true,
        link: function (scope, element, attr) {
           // console.log(attr);
            //scope.mssettings= {displayProp : "name"};
            //scope.selectOptions = [ {id: 1, label: "David"}, {id: 2, label: "Jhon"}, {id: 3, label: "Danny"} ];
            scope.$on('$destroy', function() {
                updateSlctdModel();
            });
            scope.selectOptions = scope.$eval(attr['optionsmodel']);
            scope.selectedModel = scope.$eval(attr['selectedmodel']);
            scope.example1model = [];
            if(attr.groupby){
                scope.groupby = true;
                //console.log(attr.parentmodel);
                scope.parentModelOptions = scope.$eval(attr.groupby);
                scope.parentModelValues = scope.$eval(attr.parentmodel);

            }else{
                scope.groupby=false;

            }

            if(attr.parentfield){
                scope.parentField = true;
                scope.childModel = scope.$eval(attr['childmodel']);
                scope.childOptions = scope.$eval(attr['childoptions']);
                console.log(scope.childModel);
                console.log(scope.childOptions);
            }

            if(attr['groupByModel']){
                scope.groupByModel = scope.$eval(attr['groupByModel']);
            }
            scope.removeSelectedItem = function(e,id){
                scope.$broadcast('removeItem',e,id);
            }

            var updateSlctdModel= scope.$on("updateSelectedModel",function(event,obj){
                scope.selectedModel = obj;
                //$timeout(function(){scope.$apply()},0);
            });
            //console.log(scope.selectOptions);

            console.log('multiple select created');
            //console.log(scope.selectedModel);
        }
    }
}

/* *** function definition of ajaxAutocompleteNew directive ****/
function ajaxAutocompleteNew($parse,$compile,$rootScope,showPageService,formService,dataManipulationService){
    return {
        scope: true,
        restrict:'A',
        require: 'ngModel',
        link: function ($scope, element, attrs,controller) {
            function setViewVal(modelValue){
                if(modelValue){
                    if(fieldData.properties && fieldData.properties.multiple){
                        return "";
                    }
                    if(!modelValue.name && modelValue.firstName && modelValue.lastName){
                        return modelValue.firstName +" "+ modelValue.lastName;
                    } else{
                        return modelValue.name;
                    }

                } else{
                    return "";
                }

            }
            controller.$formatters.push(setViewVal);
            element.unbind();
            if(!element.data("fieldData")){
                element.data("fieldData", JSON.parse(element.attr("field-json")));
            }
            let dataToPost = {},
            	typeMapper = {"supplier":1,"contracts":61},
            	dropDownType,
                customerId,
            	entityTypeId,
            	model,
            	parentEntityTypeId="",
            	parentEntityId="",
            	pageEntityTypeIdValue = "",
            	fieldId = "",
            	fieldData = element.data("fieldData"),
            	modelArray = element.attr("modelAccessor").split("."),
            	urlParams = "",
            	valueEndField = attrs.taghtmltype == 3 ? "defaultValue" : "values",//contains the endd Value Node
            	valuePrefix = "",//contains the path before the end Node
            	valueField = ((valuePrefix.trim().length > 0)?valuePrefix + ".":"") + valueEndField;
            if (fieldData != null && typeof fieldData != "object" && typeof fieldData == "string" ) {
                fieldData = showPageService.getModelfromString.call($scope, fieldData);
                element.data("fieldData", fieldData);
            }
            if(!fieldData && attrs.fieldJson){
                fieldData = JSON.parse(attrs.fieldJson);
            }
            const url = window.location.href;
            if (url.includes("templateWizard") && fieldData.apiName) {
                fieldData.name = fieldData.apiName;
            }
            var dynamicfieldid = $(element).closest(".label-height").attr("dynamicfieldid");
            var dynamicfieldvalue = $(element).closest(".label-height").attr("dynamicfieldvalue");
            $scope.offline = false;
            if(element.attr("offline") == 'true'){
                $scope.offline = true;
            }
            modelArray.pop();
            element.attr("name",randomString(12));
            if(fieldData){
                element.attr("fieldName",fieldData.name);
            }
            model = showPageService.getModelfromString.call($scope,modelArray.join("."));
            $scope.appendSelectedElements = function(el,fd){
                el && (element = el);
                fd && (fieldData = fd);
                var selectedElmDiv;
                if(element.closest('.label-height').find('.jx-selected').length){
                    selectedElmDiv = element.closest('.label-height').find('.jx-selected');
                }else{
                    selectedElmDiv = angular.element('<div/>',{'class':"jx-selected"});
                    element.before(selectedElmDiv);
                }
                selectedElmDiv.html('');
                if(element.attr("fieldname")=="states")
                    element.parent().find(".jx-selected").html('');
                fieldData.selectedVals.forEach(function(d,i){
                    var tempField2 = angular.element(document.createElement('input')).attr({'type':'button',
                        'onclick': 'event.preventDefault(); event.stopPropagation();$(this).parent().find(".ui-autocomplete-input").scope().removeMe($(this),'+d.id+')',
                        'class':'ui-icon ui-icon-close showSelected',
                        'style':'top:2px'
                    });
                    var selectedElement = angular.element('<span/>',{'class':'showSelected abc badge1 jx-msBadge','index':i,'text':d.name});
                    selectedElement.append(angular.element('<i/>',{'class':"icon-close",'onclick':'event.preventDefault(); event.stopPropagation();$(this).closest(".label-height").find(".ui-autocomplete-input").scope().removeMe($(this),'+d.id+')'}));
                    //var selectedElement = angular.element("<input type = 'text' class = 'showSelected' index = "+i+" readonly = 'readonly' value = '"+d.name+"'/>");
                    selectedElement.find("i").attr("data-option",JSON.stringify(d));
                    selectedElmDiv.append(selectedElement);
                    //element.before(selectedElement);
                    //element.before(tempField2);
                });
            };
            if(fieldData.name == "supplier" || fieldData.name == "suppliers" || fieldData.name == "relations"){
                dropDownType = 2;
                entityTypeId = 1;
                if (_.has($scope.globalData, "entityTypeId")){
                    pageEntityTypeIdValue = $scope.globalData.entityTypeId;
                }
            }else if(fieldData.name == "contract" || fieldData.name == "contracts" || fieldData.name == "parentName"){
                if(fieldData.properties && fieldData.properties.dependentParentFieldsName){
                    dropDownType = 41;
                    entityTypeId = 315;
                    if(fieldData.properties && fieldData.properties.multiSupplierGBContract){
                        entityTypeId = 61;
                        dropDownType = 1;
                    }
                }else{
                    dropDownType = 1;
                    entityTypeId = 61;
                }
            }else if(fieldData.name == "parentDocument" || fieldData.name == "contract"){
                dropDownType = 1;
                entityTypeId = 61;
            }else if(fieldData.fieldName == "stakeHolder" || fieldData.name == "requestedBy" || fieldData.name =="serviceIdSupplier" || fieldData.name =="purchaseOrder" || fieldData.name =="po" || fieldData.name =="pos" || fieldData.name =="functions" ||fieldData.name =="services" || fieldData.name =="contractRateCard" ){
                if(fieldData){
                    fieldId = fieldData.id;
                }
                if(fieldData.name =="serviceIdSupplier" ){
                    dropDownType = 23;
                } else if(fieldData.name =="purchaseOrder" || fieldData.name =="po" || fieldData.name =="pos"){
                    dropDownType = 25;
                    entityTypeId = 181;
                }
                else if (fieldData.name == "services"){
                    dropDownType = 9;
                    entityTypeId = 25;
                }
                else if (fieldData.name == "contractRateCard"){
                    dropDownType = 68;
                    entityTypeId = 366;
                }
                else if (fieldData.name == "functions"){
                    dropDownType = 50;
                    entityTypeId = 27;
                }
                else{
                    dropDownType = 3;
                }
                if($scope.data){
                    if($scope.data.entityTypeId && $scope.data.entityTypeId.values){
                        entityTypeId  = $scope.data.entityTypeId.values;
                    }
                    if($scope.data.id && $scope.data.id.values && !$rootScope.bulkNovation){
                        urlParams  += "&entityId=" + $scope.data.id.values;
                    }
                    if($scope.data.parentEntityTypeId && $scope.data.parentEntityTypeId.values){
                        parentEntityTypeId= $scope.data.parentEntityTypeId.values;
                    }
                    if($scope.data.parentEntityId && $scope.data.parentEntityId.values){
                        parentEntityId=$scope.data.parentEntityId.values;
                    }
                    if($scope.data.supplier && $scope.data.supplier.values){
                        urlParams  += "&relationId=" + ($scope.data.supplier.values.id ? $scope.data.supplier.values.id : "");
                    }
                    if(parentEntityTypeId && parentEntityTypeId == 1) {
                        var supplierIds = _.has($scope.data,"parentEntityIds.values[0]") && $scope.data.parentEntityIds.values.toString();
                    }
                }
            }
            else if(fieldData.name == "vendorContractingParty"){
                dropDownType = 8;
                entityTypeId = 72;
            } else if (fieldData.dynamicField) {
                dataToPost.entityFieldId = fieldData.id;
                dropDownType = 16;
                entityTypeId = 124;
                fieldId = fieldData.id;
                if($scope.data) {
                    var parentIds = ( ($scope.data.parentEntityIds && $scope.data.parentEntityIds.values && $scope.data.parentEntityIds.values[0])
                        || ($scope.data.parentEntityId && $scope.data.parentEntityId.values) )
                    if ($scope.data.parentEntityTypeId && $scope.data.parentEntityTypeId.values && parentIds) {
                        parentEntityTypeId = $scope.data.parentEntityTypeId.values;
                        parentEntityId = parentIds;
                    }
                }
            }
            else if (fieldData.name == "existingPageReferences") {
                dropDownType = 28;
                entityTypeId = 12;

                //$scope.bulkEntityId.entityIds
            }

            else if (fieldData.name == "category") {
                dropDownType = 29;
                entityTypeId = 134;
            }
            else if (fieldData.name == "definitionCategory") {
                dropDownType = 30;
                entityTypeId = 208;
            }
            else if (fieldData.name == "agreementTypes" || fieldData.name == "agreementType") {
                dropDownType = 31;
                entityTypeId = 131;
            }
            else if (fieldData.name == "recipientMarkets") {
                dropDownType = 32;
                entityTypeId = 157;
            }
            else if (fieldData.name == "contractingEntity" || fieldData.name == "clientContractingEntity") {
                dropDownType = 33;
                entityTypeId = 72;
            }
            else if (fieldData.name == "customer"){
                dropDownType = 34;
                entityTypeId = 1;
            }
            else if (fieldData.name == "changeRequest"){
                dropDownType = 35;
                entityTypeId = 63;
            }
            else if(fieldData.name == "states"){
                dropDownType = 42;
                entityTypeId = 64;
            }else if (fieldData.name == "sourceTitle" || (fieldData.name == "contractParent" && fieldData.properties && fieldData.properties.dependentParentFieldsName)){
                dropDownType = 41;
                entityTypeId = 315;
                if (_.has($scope.globalData, "entityTypeId")){
                    pageEntityTypeIdValue = $scope.globalData.entityTypeId;
                }
                if(_.has($scope.data,"entityTypeId.values") && $scope.data.entityTypeId.values == 160
                    && _.has($scope.data,"customer.values.id")){
                    customerId = $scope.data.customer.values.id;

                }
            }
            else if (fieldData.name == "users" || fieldData.name == "UsersCreateDelegation"){
                dropDownType = 3;
                entityTypeId = 20;
                pageEntityTypeIdValue = 314;
            }
            else if(fieldData.name == "recipientCompanyCodes") {
                dropDownType = 51;
                entityTypeId = 159;
            }
            else if(fieldData.name == "recipientClientEntities") {
                dropDownType = 14;
                entityTypeId = 158;
            }
            else if(fieldData.name == "contractingCompanyCodes") {
                dropDownType = 51;
                entityTypeId = 159;
            }
            else if(fieldData.name == "contractingClientEntities") {
                dropDownType = 14;
                entityTypeId = 158;
            }
            else if(fieldData.name == "createdFor") {
                dropDownType = 14;
                entityTypeId = 158;
            }
            else if (fieldData.name == "services"){
                dropDownType = 9;
                entityTypeId = 25;
            }
            else if (fieldData.name == "functions"){
                dropDownType = 50;
                entityTypeId = 27;
            }
            else if(fieldData.name == "novationReplaceSupplier" || fieldData.name == "novationNewSupplier"){
                dropDownType = $scope.novateData.supplierOptionId;
                entityTypeId = $scope.novateData.supplierEntityTypeId;
                pageType = $scope.novateData.destinationPageType;
                if($scope.novateData.sourceRelationid){
                    urlParams  += "&relationId="+$scope.novateData.sourceRelationid;
                }else if($scope.novateData.sourceRelations.length){
                    urlParams  += "&relationId="+$scope.novateData.sourceRelations[0].id;
                }
                urlParams  += "&novation=true";
            }else if(fieldData.name == "moveDocumentSupplier" ){
                dropDownType = 2;
                entityTypeId = _.get($scope.data,"entityTypeId.values");
                pageType = 6;
                urlParams  += "&novation=true";
            }
           else if(fieldData.name == "novationParentContract" ){
                dropDownType = $scope.novateData.contractOptionId;
                entityTypeId = $scope.novateData.contractEntityTypeId;
                pageType = $scope.novateData.destinationPageType;
                urlParams  += "&novation=true";
            }else if(fieldData.name == "moveDocumentContract" ){
                dropDownType = 1;
                entityTypeId = _.get($scope.data,"entityTypeId.values");
                pageType = 6;
                urlParams  += "&novation=true";
            }
            else if(fieldData.name == "projects" ){
                dropDownType = 59;
                entityTypeId = 316;
                pageType = 1;
                if (_.has($scope.globalData, "entityTypeId")){
                    pageEntityTypeIdValue = $scope.globalData.entityTypeId;
                }
            }
            else if( fieldData.properties && (fieldData.properties.parentMap ||  fieldData.properties.childMap) ){
                dropDownType =53;
                $scope.notAddExtra = true;
            }
            else if(fieldData.name == "referenceDocuments"){
                dropDownType = 56;
                $scope.notAddExtra = true;
            }
            else if(fieldData.name == "contractProjects"){
                dropDownType = 59;
                entityTypeId = 316;
            }
            if(_.has($scope.data, "entityTypeId.values") && pageEntityTypeIdValue == ""){
                pageEntityTypeIdValue = $scope.data.entityTypeId.values;
            }
            if(window.location.href.includes("templateWizard/cdr")) {
                pageEntityTypeIdValue = fieldData.entityType?.id || 160;
            }
            var dynamicFieldParams = "";
            if(dynamicfieldid && dynamicfieldvalue){
                dynamicFieldParams = "&dynamicFieldValue=" + dynamicfieldvalue + "&dynamicFieldId=" + dynamicfieldid;
            }
            if($scope.metadatasearchPage)
                var ajaxUrl = appName + "/options/"+dropDownType+"?pageType=7&entityTpeId="+entityTypeId + "&parentEntityTypeId="+parentEntityTypeId+"&parentEntityId="+parentEntityId+"&fieldId="+fieldId + "&pageEntityTypeId="+pageEntityTypeIdValue + urlParams;
            else if($scope.novationDialogInstance || $scope.moveDocumentDialogInstance){
                var ajaxUrl =  appName + "/options/"+dropDownType+"?pageType="+pageType+"&entityTpeId="+entityTypeId + urlParams;
            }
            else{
                if(parentEntityTypeId){
                    var ajaxUrl = appName + "/options/"+dropDownType+"?pageType=1&entityTpeId="+entityTypeId + "&parentEntityTypeId="+(parentEntityTypeId || "")+"&parentEntityId="+parentEntityId+"&pageEntityTypeId="+pageEntityTypeIdValue+"&fieldId="+fieldId + urlParams + dynamicFieldParams;
                }else{
                    var ajaxUrl = appName + "/options/"+dropDownType+"?pageType=1&entityTpeId="+entityTypeId +"&parentEntityId="+parentEntityId+"&pageEntityTypeId="+pageEntityTypeIdValue+"&fieldId="+fieldId + urlParams + dynamicFieldParams;
                    if($scope.notAddExtra){
                        ajaxUrl = appName +  "/options/" + dropDownType +"?pageType=1&entityTpeId=316&parentEntityId=&pageEntityTypeId=316&fieldId=&expandAutoComplete=true&offset=0";
                    }
                }
                if(supplierIds){
                    ajaxUrl += "&supplierIds="+supplierIds;
                }
            }
            if($scope.fieldData  && $scope.fieldData.properties && $scope.fieldData.properties.sendForSignature ){
                // entityTypeId = $scope.fieldData.entityTypeId;
                // var entityId = $scope.fieldData.entityId;
                // var pageType = $scope.fieldData.pageType;
                 ajaxUrl= appName +  "/esign/user/details?offset=0";
                // ajaxUrl = appName +  "/options/3?vendorId=&relationId=&entityTpeId="+ entityTypeId+"&entityId=" +entityId + "&pageType="+pageType;
            }
            if($scope.aedata && $scope.aedata.aeBulkDownload){
                dropDownType=1;
                entityTypeId =63;
                pageType =1
                // &entityTpeId="+ entityTypeId
                ajaxUrl = appName +  "/options/3?vendorId=&relationId=" + "&pageType=" +pageType;
            }
            var postData;
            if($scope.bulkEntityId && $scope.bulkEntityId.entityIds){
                ajaxUrl = appName + "/options/"+dropDownType+"?pageType=10&entityTpeId="+entityTypeId+"&fieldId="+fieldId+"&pageEntityTypeId="+pageEntityTypeIdValue;
                var entityIdVal = {};
                entityIdVal.entityIds = $scope.bulkEntityId.entityIds;
                postData = JSON.stringify(entityIdVal);
            }
            if(dropDownType ){ //Check included for exception SIR-157907
            if(fieldData.groupBy){
                parentEntityTypeId = typeMapper[fieldData.groupBy];
                // element.attr("disabled","disabled");
                var emptyVal = (fieldData.properties && fieldData.properties.multiple) ? [] : {};
                $scope.$watch('data.'+fieldData.groupBy + ".values",function(newVal,oldVal){
                    if(newVal && newVal instanceof Array !== true && newVal.id){
                        element.removeAttr("disabled");
                        if($scope.metadatasearchPage) {
                            ajaxUrl = appName + "/options/" + dropDownType + "?pageType=7&entityTpeId=" + entityTypeId + "&parentEntityTypeId=" + parentEntityTypeId + "&parentEntityId=" + newVal.id;
                        }else {
                            if(parentEntityTypeId){
                                ajaxUrl = appName + "/options/" + dropDownType + "?pageType=1&entityTpeId=" + entityTypeId + "&parentEntityTypeId=" + parentEntityTypeId + "&parentEntityId=" + newVal.id;
                            }else if(customerId){
                                ajaxUrl = appName + "/options/" + dropDownType + "?pageType=1&entityTpeId=" + entityTypeId  + "&parentEntityId=" + newVal.id+"&customerId="+customerId;
                            } else {
                                ajaxUrl = appName + "/options/" + dropDownType + "?pageType=1&entityTpeId=" + entityTypeId  + "&parentEntityId=" + newVal.id;
                            }
                            $scope.tempUrl = ajaxUrl;
                        }
                        if(oldVal && newVal.id != oldVal.id){
                            element.siblings(".showSelected").remove();
                            fieldData.selectedVals = angular.copy(emptyVal);
                            model[valueField] = angular.copy(emptyVal);
                        }
                    } else if(newVal &&  newVal instanceof Array !== true){
                        element.val("");
                        element.siblings(".showSelected").remove();
                        fieldData.selectedVals = angular.copy(emptyVal);
                        model[valueField] = angular.copy(emptyVal);
                    }
                    else if(newVal && !$rootScope.isBottomUpSelected){
                        var valuesSelected = [];
                        var parentIds = [];
                        newVal.forEach(function(pt){parentIds.push(pt.id)});
                        model[valueField] && model[valueField].forEach(function(d){
                            if(parentIds.indexOf(d.parentId) > -1){
                                valuesSelected.push(d);
                            }
                        });
                        fieldData.selectedVals = valuesSelected;
                        model[valueField] = valuesSelected;
                        $scope.appendSelectedElements(element,fieldData);

                    }
                })
            }
        	if(fieldData.properties && fieldData.properties.multiple){
        		if(!model.values){
        			model.values = [];
        			fieldData.selectedVals = [];
        		} else if(model.values && angular.isArray(model.values)){
        			fieldData.selectedVals = model.values;
        			$scope.appendSelectedElements(element,fieldData);
        		}
        	} else{
        	    if(fieldData.properties && fieldData.properties.sendForSignature){
                    var ele = $('.jxx-stakeHolders');
                    ele.change(function () {
                        if($(this).val() == ""){
                            $scope.comeBackInForm();
                        }
                    });
                }else{
                    element.change(function(e){
                        if($(this).val() == ""){
                            model[valueField] = null;
                            showPageService.emptyDependentField.call($scope,fieldData);
                            if(fieldData.name === "moveDocumentSupplier") {
                                $scope.moveDocPostData.documentContract = {}
                                $scope.errorObj['suppliers'] = true;
                                $scope.errorObj['documentContract'] = true;
                            }

                            dataManipulationService.toggleTabNavigation(false);
                            var targetFieldId = angular.element(this).closest(".label-height").attr("data-target-field-id");
                            if(targetFieldId){
                                $rootScope.$emit("change event triggered for source field", targetFieldId);
                            }
                            if(e.originalEvent){
                                formService.emptySupplierDependentField(this);
                            }
                        }else  {
                            if($scope.moveDocumentPopupObj) {
                                if(fieldData.name === "moveDocumentSupplier") {
                                    $scope.errorObj['suppliers'] = false;
                                }
                                if(fieldData.name === "moveDocumentContract") {
                                    $scope.errorObj['documentContract'] = false;
                                }
                            }
                        }
                    })
                }
        	}
        	var idRemove ;
        	$scope.removeMe = function(elem,id){
                var index;
                idRemove=id;
                var selectedValues = [];
                fieldData.selectedVals.forEach(function(d,i){
                    if(d.id == id){
                        index = i;
                    }
                });
                if($(elem).closest(".label-height").attr("data-target-field-id")){
                    $(".portFieldset_"+id).remove();
                }
                showPageService.emptyDependentField.call($scope,fieldData,idRemove);
                formService.emptySupplierDependentField(elem,true);
                fieldData.selectedVals.splice(index,1);
                elem.closest('.jx-msBadge').remove();
                checkForBottomUpChanges();
        	}
        	$scope.getParentFieldID  = function (dependentFieldParentName) {
        	    depParFieldName = depParFieldName ? depParFieldName :dependentFieldParentName;
                var dynData = $scope.data.dynamicMetadata;
                if(dynData[depParFieldName]){
                    $scope.parentFieldId = dynData[depParFieldName].id;
                    $scope.parentFieldName = depParFieldName;
                }else{
                    dynData = $scope.data && $scope.data[depParFieldName];
                    var parentId =[];
                    const values = $scope.data[depParFieldName]?.values;
                    if(!_.isEmpty(values) ){
                        [].concat(values).forEach((elem)=>{
                            parentId.push(elem.id);
                        });
                    }

                    $scope.parentFieldId = parentId.toString();
                    $scope.parentFieldName = depParFieldName;
                }
                return dynData;
            }
        	var requestedByFilterFunction = function(data){
        		var toReturn = true;
        		if(data.idTypes)
        		{
        			toReturn =false;
        		}
        		
        		return toReturn;
        	}
            $scope.tempUrl = ajaxUrl;
        	var depParFieldName = element.closest(".autcompletePopGlobal").length? element.closest(".autcompletePopGlobal").attr('groupBy'):element.attr('groupBy');
        	if(depParFieldName){
                $scope.getParentFieldID();
        	}
        	$(element).autocomplete({
                source: function(request, response) {
                    sourceApiCall(request,response);
                },
                messages: {
                    noResults: '',
                    results: function() {}
                },
                minLength: 0,
                open: function() {
                    
                },
                close: function() {

                },
                classes:{
                 "ui-autocomplete": "sirionUI2"
                },
                create:function(event, ui){
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var itemToAppend;
                        ul.addClass('sirionUI2');
                        if(item.idTypes){
                            itemToAppend = $('<li>')
                                .append('<a><span class="icon-usergroup"></span>'+ item.label  + '</a>')
                                .appendTo(ul);
                        }
                        else
                        {
                            if(item.mapper) {
                                itemToAppend = $('<li class="mapper">')
                                    .append('<span>' + item.label + '</span>')
                                    .appendTo(ul);
                            } else {
                                itemToAppend = $('<li>')
                                    .append('<a>' + item.label + (_.get(item, 'properties.email') ? ' <span ng-if="item && item.properties.email" class="usr_email">'+item.properties.email+'</span>':'')+'</a>')
                                    .appendTo(ul);
                            }
                        }
                        return itemToAppend;
                    };
                }
                ,

                select: function(event, ui) {
                    model = showPageService.getModelfromString.call($scope,modelArray.join("."));
                    event && event.stopPropagation();
                    var it = angular.copy(ui.item);
                    delete it.label; delete it.value;
                    if(it.name) {
                        it.name = it.name.replace(/&amp;/g, "&").replace(/amp;/g, "");
                    }
                    var targetFieldId = $(event.target).closest(".label-height").attr("data-target-field-id"), hasMultiOptions = false;
                    if(targetFieldId){
                        if(fieldData.properties && fieldData.properties.multiple){
                            hasMultiOptions = true;
                        }
                        $rootScope.$emit("change event triggered for source field", targetFieldId, ui.item, hasMultiOptions);
                    }
                    if(event.originalEvent && !(window.location.hash.indexOf('sendSignature') >-1 || window.location.hash.indexOf('templateWizard') >-1) && !$scope.aedata){
                        formService.emptySupplierDependentField(this);
                    }
                    if(fieldData.properties && fieldData.properties.multiple){
                        // This IF condition is for testing purpose only. Need to remove it after testing
                        if(fieldData.properties.parentMap) {
                            fieldData.selectedVals = [];
                        }
                        fieldData.selectedVals.push(it);
                        model[valueField] = fieldData.selectedVals;
                        element.siblings(".showSelected").remove();
                        $scope.appendSelectedElements(element,fieldData);

                    } else if($scope.aedata && $scope.aedata.aeBulkDownload){
                        it['roleGroupId'] =event.target.id;
                        if(it.idTypes && (it.idTypes instanceof Array)){
                            it['group'] =true;
                        }else{
                            it['group'] =false;
                        }
                        $scope.setAeDownloadStakeHolder(it);
                        setTimeout(function () {
                            event.target.value = '';
                        },5);
                    } else{
                        if(element.attr("valuesInArray") && (element.attr("valuesInArray") == true || element.attr("valuesInArray") == "true") ) {
                            if(model[valueField] === null)
                                model[valueField]=[];

                            if(element.attr("single")){
                                model[valueField] = [it];
                            } else{
                                if(model[valueField] == null){
                                    model[valueField] = [];
                                }
                                if ($scope.fieldData && $scope.fieldData.properties && $scope.fieldData.properties.sendForSignature) {
                                    if (model[valueField].length <= 20) {
                                        model[valueField].push(it);
                                    }
                                    else {
                                        $rootScope.$emit("Selection limit exceeded", model);
                                    }
                                }
                                else{
                                    model[valueField].push(it);
                                }
                            }
                        } else{
                            model[valueField] = it;
                            fieldData.singleSelectValue = [it];
                        }
                    }
                    showPageService.emptyDependentField.call($scope,fieldData, null, true);
                    if (fieldData.groupBy && fieldData.groupBy == "contracts" && fieldData.id == 12030) {
                        $scope.changeContractFields("data." + fieldData.groupBy + ".options.selectedData", "data." + fieldData.groupBy + ".options.data", "data." + fieldData.name + ".values");
                    }
                    $scope.checkFieldType && $scope.checkFieldType(fieldData, element);
                    if(!$scope.$$phase){
                        $scope.$apply();
                    }
                    checkForBottomUpChanges();
                    if(fieldData && fieldData.properties && fieldData.properties.sendForSignature){
                        $scope.addRowToList(event,true);
                        return ;
                    }
                    if((fieldData.properties && fieldData.properties.multiple)|| (fieldData.fieldName == "stakeHolder") && !element.attr("single")){
                        element.val("").blur();;
                        return false;
                    }
                }

            }).bind('focus', function(){ $(this).autocomplete("search")}); // To trigger the options call as soon as input element is in focus (tab and click)
            // console.log("element, attrs :",element, attrs, $rootScope);
            }else{
                window.systemWarning("option ID is not found");
            }

            var checkForBottomUpChanges = function () {
                if(fieldData && fieldData.properties && fieldData.properties.filter){
                    sourceApiCall('',null,true,fieldData.selectedVals || fieldData.singleSelectValue);
                }
            }

            var getLayoutData = function (cData,dynModel) {
                let objectToReturn = {};
                if(cData && dynModel){
                    const data = cData;
                    objectToReturn = _.get(data,dynModel);
                }
                return objectToReturn || {};
            }

            var sourceApiCall = function(request, response,isBottomUpSelected,selectedValues) {
                model = showPageService.getModelfromString.call($scope,modelArray.join("."));
                var boxFieldType = element.data("fieldData");
                if(fieldData && fieldData.groupBy) {
                    var dynData = $scope.getParentFieldID();
                }
                if(!$scope.offline){
                    var endPoint = ajaxUrl;
                    if((fieldData.groupBy || fieldData.dependentField || _.get(fieldData,"dependentFields.length")) && fieldData.id) {
                        endPoint = SirionUtils.removeURLParameterVer2(endPoint,"fieldId");
                        endPoint += "&fieldId=" + fieldData.id;
                    }

                    const getParentOptionIds = (values) => {
                        const allValues = [].concat(values || []);
                        return allValues.map((obj) => {
                            return obj.id;
                        })
                    }

                    if (ajaxUrl.indexOf("undefined") == -1) {
                        endPoint = commonUtil.appendSupplierToUrl(fieldData,$rootScope,$scope, endPoint);
                        if(isBottomUpSelected) {
                            let splitedUrl = endPoint.split('?');
                            splitedUrl[0] += '/filter';
                            endPoint = splitedUrl.join('?');
                        }
                        if(fieldData.properties && fieldData.properties.dependentParentFieldsName){
                            if(commonUtil.checkDependentFieldValues(fieldData,$scope.data)){
                                endPoint = commonUtil.appendQueryParamsToGlobalCreateFieldUrl(fieldData,$scope.data,endPoint);
                            }else{
                                return false;
                            }
                        }
                        var postDataJson = {};
                        var postData;
                        var type = "GET";
                        if(fieldData.name == "recipientCompanyCodes" || fieldData.name == "recipientClientEntities" || fieldData.name == "contractingCompanyCodes" || fieldData.name == "contractingClientEntities" || fieldData.name == "createdFor" || fieldData.name == "services" || fieldData.name == "functions") {
                            if($scope.data.id.id || $scope.data.id.values){
                                endPoint += "&pageEntityId="+($scope.data.id.id || $scope.data.id.values);
                            }
                            if(fieldData.properties && typeof fieldData.properties.recipient == "boolean") {
                                endPoint += "&recipient="+fieldData.properties.recipient;
                            }
                        }
                        if(fieldData.fieldName == "stakeHolder" && $scope.data.relations && $scope.data.relations.values) {
                            postDataJson["relationIds"] = $scope.data.relations.values.map(function(obj){return obj.id});
                            postData = JSON.stringify(postDataJson);
                            type="POST";
                        }
                        else if($scope.newEntityCall && fieldData && (fieldData.name == "contracts" || fieldData.name == "contractParent") ) {
                            if(!postData){
                                postData = {};
                            }
                            if(fieldData.dependentField || fieldData.dependentFields) {
                                postData["relationIds"] = showPageService.getOnlyFieldIds.call($scope,fieldData.dependentField || fieldData.dependentFields);
                            }
                            postData = JSON.stringify(postDataJson);
                            type="POST";
                        } else if($("[name='globalCountries']").length>0 && $scope.data.globalCountries && endPoint.indexOf("/42")>-1){
                            if(window.location.href.indexOf("/metadatasearch")>-1 || window.location.href.indexOf("/search")>-1){
                                postDataJson.globalCountries = null;
                            } else {
                                postDataJson.globalCountries = (!$scope.data.globalCountries.values && $scope.data.globalCountries.values.length==0)?[]:$scope.data.globalCountries.values.map(function(a) {return a.id;});
                            }
                            postData = JSON.stringify(postDataJson);
                            type="POST";
                        }
                        else if($("[name='countries']").length>0 && $scope.data.countries && endPoint.indexOf("/42")>-1){
                            if(window.location.href.indexOf("/metadatasearch")>-1 || window.location.href.indexOf("/search")>-1){
                                postDataJson.globalCountries = null;
                            } else {
                                postDataJson.globalCountries = (!$scope.data.countries.values || $scope.data.countries.values.length==0)?[]:$scope.data.countries.values.map(function(a) {return a.id;});
                            }
                            postData = JSON.stringify(postDataJson);
                            type="POST";
                        }
                        var selectedDynChildVals = [];
                        var parentDynId = "";
                        var depPar = element.closest(".autcompletePopGlobal").length? element.closest(".autcompletePopGlobal").attr('groupBy'):element.attr('groupBy');
                        var optionIds = [];
                        if($scope.parentFieldId){
                            let parentFieldWithOptionIds={};
                            let parentFieldIds = [];
                            const groupByList = fieldData.groupByIds ?? fieldData.groupBy ?? [];
                            [].concat(groupByList).forEach((name) => {
                                const parentField = getLayoutData($scope.data, name);
                                parentFieldIds.push(parentField?.id);
                                const values = parentField?.values ? [].concat(parentField?.values) : [];
                                parentFieldWithOptionIds[parentField?.id] = getParentOptionIds(values);
                            });
                            type="POST";
                            postData=  JSON.stringify({parentFieldIds,parentFieldWithOptionIds});
                            if(dynData[depPar]){
                                endPoint = endPoint + "&parentFieldId="+$scope.parentFieldId;
                            }else{
                                endPoint = endPoint + "&parentFieldId="+ dynData.id;
                            }

                        }
                        // else if(depPar && !$scope.data[depPar].id && !dynData[depPar].id){
                        //     return ;
                        // }
                        else if($scope.bulkEntityId && $scope.bulkEntityId.entityIds){
                            type = "POST";
                        }
                        else if(fieldData.properties && (fieldData.properties.parentMap ||  fieldData.properties.childMap) || fieldData.name == "referenceDocuments"){
                            let retObj = $scope.getPostDataForParentOrChildReferences(fieldData);
                            type = retObj.type;
                            postData =JSON.stringify(retObj.postData);
                        }
                        else if(fieldData.name == "novationParentContract" || fieldData.name == "moveDocumentContract" ){
                            type = "POST";
                            postData = {};
                            if(_.get($scope.novationPopupObj,'moveContract') || _.get($scope.moveDocumentPopupObj,'moveDocument')){
                                postData["relationIds"] = [];
                                if(_.has($scope.data,"relations.values") && !_.get($scope.moveDocumentPopupObj,'moveDocument')) {
                                    postData["relationIds"] = _.compact($scope.data.relations.values.map(function (obj) {
                                        if (obj.id) return obj.id
                                    }));
                                }
                                if(_.get($scope.moveDocumentPopupObj,'moveDocument') && !$rootScope.bulkNovation) {
                                    postData["relationIds"] = [$scope.moveDocPostData.suppliers.values.id]
                                    endPoint  += "&entityId="+$scope.data.id.values;
                                }
                                else if(!$rootScope.bulkNovation){
                                    endPoint  += "&moveContract=true&entityId="+$scope.novateData.sourceId;
                                }else endPoint  += "&moveContract=true";

                                if ($scope.data.entityTypeId?.values == 1) {
                                    postData["relationIds"].push($scope.data.id.values);
                                }
                            }
                            else{

                                let selSupToBeReplaced = $scope.findExistingSuppliers($scope.supplierTable);
                                let  newSuppliers = $scope.novatePostData.newRelations.values.map(obj=> { return obj.id});
                                selSupToBeReplaced = $scope.novateData.sourceRelations.filter(obj => {if(!selSupToBeReplaced.includes(obj))return obj.id}).map(obj => obj.id);
                                postData["relationIds"] =   _.compact($scope.supplierTable.map(function(obj){if(obj.replacedSuppliers.values) return  obj.replacedSuppliers.values.id}));
                                postData["relationIds"] = _.concat(postData["relationIds"], selSupToBeReplaced, newSuppliers);
                            }

                            postData = JSON.stringify(postData);
                        }
                        if(endPoint.indexOf("NaN") > -1){
                            endPoint = endPoint.replace("NaN" , "");
                        }
                        if(fieldData && fieldData.properties && fieldData.properties.sendForSignature){
                            if(request.term == '' || !request.term){
                                $scope.enableAllFields();
                                return;
                            }
                        }
                        if(!$scope.aedata){
                                if(!$scope.data){
                                    $scope.data = {
                                        dynamicMetadata:null
                                    }
                                }
                            endPoint = showPageService.getsourceId(fieldData,$scope.data.dynamicMetadata,endPoint);
                        }
                        if(fieldData.properties && fieldData.properties.filter) {
                            endPoint = endPoint + '&filter=' + fieldData.properties.filter;
                            type = "GET"
                            postData = undefined;
                        }
                        if(isBottomUpSelected) {
                            endPoint = endPoint.replace(`options/${dropDownType}/filter`,`options/${fieldData.id}/filter`);
                            postData = {optionIds: [].concat(selectedValues).reduce((acc,op) => {
                                    op && acc.push(op.id);
                                    return acc;
                                } ,[])};
                            type = "POST"
                            postData = JSON.stringify(postData)
                        }
                        if(request && request.term)
                           endPoint = endPoint + "&query=" + encodeURIComponent(request.term)

                        if( $scope.parentFieldId &&  !_.get(fieldData,"properties.filter") ) {
                            let pd = typeof postData == "string" ? JSON.parse(postData) : postData;
                            const missingOptions = Object.values(pd.parentFieldWithOptionIds).some(arr => !arr?.length);
                            if (missingOptions) return;
                        }
                        if(_.isEmpty(request?.term?.trim()) && !endPoint.includes('expandAutoComplete')){
                            endPoint += '&expandAutoComplete=true';
                        }

                        function responseHandler (data) {
                            if($scope.isMoveDocument) {
                                data.data = data.data.filter(x=> x.id != $scope.parentContractId);
                            }

                            $('input.suggest-user').removeClass('ui-autocomplete-loading');
                            var wH = $(window).height(),
                                eT = $(element).offset().top,
                                eH = $(element).outerHeight(),
                                oH = data.data.length*34>200?200:data.data.length*34;

                            let position = {
                                my:wH-eT-eH>oH? "left top" : "left bottom",
                                at:wH-eT-eH>oH? "left bottom" : "left top"
                            }
                            if($scope.bulkEdit) {
                                position = {
                                    my:wH-eT-eH>oH? "left bottom" : "left top",
                                    at:wH-eT-eH>oH? "left top" : "left bottom"
                                }
                            }
                            $(element).autocomplete("option","position",position)

                            if(fieldData.selectedVals && fieldData.selectedVals.length && data && data.data && data.data.length) {
                                data.data = data.data.filter(function (item) {
                                    return (fieldData.selectedVals.indexOf(item.id) == -1)
                                })
                            }
                            var autoData = data.data;
                            if (model && model["name"] == "requestedBy" || (boxFieldType && boxFieldType.type == "textBoxSingleSelect")) {
                                autoData = autoData.filter(requestedByFilterFunction);

                            }

                            if (model && model[valueField] && angular.isArray(model[valueField])) {
                                autoData = autoData.filter(function (d) {
                                    var present = false;
                                    model[valueField].forEach(function (d1) {
                                        if (d1.id == d.id && !present) {
                                            present = true;
                                        }
                                    })
                                    return !present;
                                });
                            }
                            if(_.get($scope,"fieldData.properties.sendForSignature") && !$scope.signOrder) {
                                autoData = _.differenceBy(autoData, $scope.selectedUserForSign, "email");
                            }
                            if(boxFieldType.name === "services" && boxFieldType.groupBy) {
                                var parentIds = _.groupBy($scope.data[$scope.parentFieldName].values,"id");
                                var tempData = [];
                                autoData.sort(function(a,b) {
                                    return a.parentName > b.parentName ? 1 : -1
                                });
                                var currentParent = '';
                                autoData.forEach(function (d,i) {
                                    if(parentIds[d.parentId]) {
                                        if (currentParent != d.parentName) {
                                            currentParent = d.parentName;
                                            var parent = {
                                                "name": currentParent,
                                                "mapper": true
                                            };
                                            tempData.push(parent);
                                        }
                                        tempData.push(d);
                                    }
                                });
                                autoData = tempData;
                            }
                            autoData.forEach(function (d) {
                                d.label = d.name;
                                d.value = d.name;
                            })
                            response && response(autoData);
                        }
                        if($rootScope.bulkNovation && modelArray.includes('parentContract')){
                            type = "POST"
                            let data=JSON.parse(postData)
                            data.entityIds=[];
                            $rootScope.docTree.forEach(item=>{
                                data.entityIds.push(item.entityId)
                            })
                            postData=JSON.stringify(data);
                        }
                        $.ajax({
                            dataType: "json",
                            type: type,
                            url: endPoint,
                            contentType: "application/json;charset=UTF-8",
                            data:postData,
                            success: function (data) {
                                $rootScope.isBottomUpSelected = isBottomUpSelected;
                                if(!isBottomUpSelected)
                                    responseHandler(data)
                                else {
                                    let dependentDrpDwns =  [];
                                    let parentLayouts = [],
                                        parentValues = [],
                                        keys = [],
                                        pKeys = _.keys(data);

                                    for(key of pKeys) {
                                        let elm = $('#mainForm').find("[fieldname="+ key +"]")[0];
                                        if(!elm) {
                                            elm = $('#mainForm').find("[label-field-name="+ key +"]")[0];
                                        }
                                        elm && dependentDrpDwns.push(elm);
                                    }
                                    for(var item of dependentDrpDwns) {
                                        let nonEditable = $(item).attr('nonEditable');
                                        if(nonEditable == "true" || nonEditable == true) {
                                            let fName = $(item).attr('label-field-name'),
                                                model = $(item).attr('dataModel'),
                                                isMultiple = $(item).attr('isMultiple'),
                                                values = data[fName].values || [];

                                            if(values && !Array.isArray(values)) {
                                                values = [].concat(values);
                                            }

                                            let displayValues = values.reduce((res,val,index)=>{
                                                if(index)
                                                    res += ', ';
                                                res += (val.name || "");
                                                return res;
                                            },'')

                                            _.set($scope,model,isMultiple == 'true' ? values : values[0]);

                                            $(item).find('.content-left').text(displayValues);

                                        }else  {
                                            let fName = $(item).attr('fieldname');

                                            if(fName != fieldData.name) {
                                                let   fldData = $(item).data("fieldData"),
                                                    model = $(item).attr('ng-model'),
                                                    values = data[fName].values || [];

                                                if(_.get(fldData,"properties.multiple")) {
                                                    fldData.selectedVals = values;
                                                    _.set($scope,model,fldData.selectedVals);
                                                    $(item).siblings(".showSelected").remove();
                                                    $scope.appendSelectedElements($(item),fldData);
                                                }else {
                                                    values[0] && $(item).val(values[0].name);
                                                }

                                            }
                                        }
                                    }
                                }
                            },
                            error: function (data) {
                                console.error(data);
                            }
                        });
                    }
                } else{
                    var optionString = element.attr("options");
                    var optionData = showPageService.getModelfromString.call($scope,optionString);
                    var showData = angular.copy(optionData);
                    if(model["name"] == "requestedBy" ||  (boxFieldType && boxFieldType.type=="textBoxSingleSelect")){
                        showData = showData.filter(requestedByFilterFunction);
                    }
                    if(model[valueField] && angular.isArray(model[valueField])){
                        showData = showData.filter(function(d){
                            var present = false;
                            model[valueField].forEach(function(d1){
                                if(d1.id == d.id && !present){present = true;}
                            })
                            return !present;
                        });
                    }
                    showData.forEach(function(option){
                        option.label = option.name;
                        option.value = option.name;
                    });
                    response( $.ui.autocomplete.filter(showData,  request.term));

                }

            }
        }
    }
}
/* ****** End of ajaxAutocompleteNew function *************/

function dragAndDropFiles(formService){
    return{
       restrict:'AC',
       link:function($scope,element,attrs){
           let lastenter;
           var targetArea = attrs.targetArea || attrs.targetarea;
           element.on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
               e.preventDefault();
               e.stopPropagation();
           });
           element.on('dragover dragenter', function (event) {
               event.preventDefault();
               lastenter = event.target;
               angular.element(this).addClass('is-dragover');
           });
           element.on('dragleave dragend', function (event) {
               if (lastenter === event.target) {
                   angular.element(this).removeClass('is-dragover');
               }
           });
           element.on('drop', function (e) {
               e.preventDefault();
               e.stopImmediatePropagation()
               angular.element(this).removeClass('is-dragover');
               var elem;
               let droppedFiles = e.originalEvent.dataTransfer.files;
               if(targetArea == 'commentsec'){
                   elem = angular.element('.jx-showPageTabContentRight.active').find('input[name="documentFileData"]');
                   elem[0].files = droppedFiles;
                   $scope.uploadFile(elem[0], undefined, droppedFiles);
                   if(!$scope.showCommentBox) {
                    $scope.showCommentBox=true;
                }
               }else if(targetArea == 'docupload'){
                   elem = angular.element('#jx-uploadContractDoc');
                   elem[0].files = droppedFiles;
                   $scope.uploadContractDoc(elem[0],droppedFiles);
               }else if(targetArea == 'notes-detail'){
                   elem = angular.element('#jx-uploadMeetingAttachment');
                   elem[0].files = droppedFiles;
                   $scope.uploadMeetingFile(elem[0],droppedFiles);
               }else if(targetArea == 'globalDocUpload'){
                   elem = angular.element('#jx-aeGlobalUpload');
                   elem[0].files = droppedFiles;
                   $scope.uploadExtractionFile(elem[0], droppedFiles);
               }else if(targetArea == 'raw-data-upload'){
                   var fileArray = Object.keys(droppedFiles).map(e => droppedFiles[e]);
                   $scope.checkFileUpload(null ,fileArray);
               }else if(targetArea == 'rowUpload'){
                   let elm = $('.uploadFileCustom[fieldId=3910]');
                   if(!elm.length){
                       elm = $('.uploadFileCustom[fieldId=3908]');
                   }
                   elm.files = droppedFiles;
                   window.globalUploadButtonActive = parseInt($(this).closest("tr").attr("DocId"));
                   $scope.documentContractUpload(elm, false);
                   elm.files = null;
               }
               else if(targetArea == 'globalUpload'){
                   let elm = $('.uploadFileCustom[fieldId=3910]');
                   let isCdr = elm;
                   if(!elm.length){
                       elm = $('.uploadFileCustom[fieldId=3908]');
                   }
                   elm.files = droppedFiles;
                   if(isCdr.length){
                       formService.buttonMapper[3910].forEach(d => {
                           if(d.properties.buttonType == 'upload'){
                               d.active = true;
                           }
                       });
                   } else {
                       formService.buttonMapper[3908].forEach(d => {
                           if(d.properties.buttonType == 'upload'){
                               d.active = true;
                           }
                       });
                   }
                   window.globalUploadButtonActive = "";
                   $scope.documentContractUpload(elm, false);
                   elm.files = null;
               }

               else if(targetArea == 'contractDocUpload'){
                   let elm = $('.uploadFileCustomCdr');
                   elm.files = droppedFiles;
                   window.globalUploadButtonActive = "";
                   $scope.documentContractUpload(elm, false);
                   elm.files = null;
               }
           });
       }
    }
}

function autoExpandTextarea($timeout){
    return{
        restrict :'AC',
        link:function($scope,element,attrs){
            element.css('word-wrap','break-word');
            element.on( 'change keydown keyup paste cut', function () {
                var elMaxHeight = parseInt(window.getComputedStyle(this,null).getPropertyValue("max-height"));
                elMaxHeight = isNaN(elMaxHeight) ? 200 : elMaxHeight;
                var elPaddingTop =  parseInt(window.getComputedStyle(this,null).getPropertyValue("padding-top"));
                elPaddingTop = isNaN(elPaddingTop) ? 0 : elPaddingTop;
                var elPaddingBottom =  parseInt(window.getComputedStyle(this,null).getPropertyValue("padding-bottom"));
                elPaddingBottom = isNaN(elPaddingBottom) ? 0 : elPaddingBottom;

                angular.element(this).height(0).height(this.scrollHeight - elPaddingTop - elPaddingBottom);
                if (angular.element(this).height() >= elMaxHeight-5) {
                    this.style.overflow = "auto";
                }else {
                    this.style.overflow = "hidden";
                }
            });

        }
    }
}

function  contractToCdrTab($rootScope,showPageService) {
    return{
        restrict: 'AE',
        templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/contractToCdr.html"),
        link: function(scope,element,attrs,controller){
            scope.documents = [];
            scope.originalContractTableData = [];
            scope.cdrSelectAll = false;
            scope.selectedChkboxCount = 0;
            scope.totalRecords = 0;

            scope.areAllCdrRowsSelected = function () {
                return !!(scope.contractTableData && scope.contractTableData.length &&
                    scope.contractTableData.every(function (elm) { return elm.directContractDocument == true; }));
            };

            scope.syncCdrHeaderFromRows = function () {
                scope.cdrSelectAll = scope.areAllCdrRowsSelected();
            };

            let getData =  showPageService.loadContractToCdrTableData(scope.selectContractId);
            getData && getData.then(res => {
                scope.contractTableData = angular.copy(res.data.data || []);
                scope.totalRecords = scope.contractTableData.length;
                scope.originalContractTableData = angular.copy(scope.contractTableData);
                scope.isEmptyContractTableData = scope.contractTableData.length > 0 ? false : true;
                createDocList(scope.contractTableData);
                scope.syncCdrHeaderFromRows();
            }).catch(error => window.systemWarning(error));

            function createDocList(data) {
                scope.documents = data && data.filter(el => el.directContractDocument == true ).map(obj => {
                    let selectedDoc = {
                        'contractDocumentId' : obj.fileId,
                        'directContractDocument':obj.directContractDocument
                    }
                    return selectedDoc;
                });
                scope.selectedChkboxCount = scope.documents.length;
            }
            scope.chkAllChange = function (isSelectAll) {
                isSelectAll = isSelectAll === true;
                scope.contractTableData = scope.contractTableData.map(function (elm) {
                    return angular.extend({}, elm, { directContractDocument: isSelectAll });
                });
                scope.selectedChkboxCount = isSelectAll ? scope.contractTableData.length : 0;
                scope.documents = isSelectAll
                    ? scope.contractTableData.map(obj => ({
                        contractDocumentId: obj.fileId,
                        directContractDocument: obj.directContractDocument
                    }))
                    : [];
                scope.cdrSelectAll = isSelectAll;
                $rootScope.documents = scope.documents;
            }

            scope.chkBoxChange = function(fileId, id){
               var row = scope.contractTableData.filter(function(obj) { return obj.id == id; })[0];
               var isChecked = row && row.directContractDocument == true;
               if(isChecked){
                   var existingDoc = scope.originalContractTableData.filter(obj => obj.id == id)[0];
                   if(!existingDoc.directContractDocument){
                       scope.selectedDoc = {
                           'contractDocumentId' : fileId,
                           'directContractDocument':false
                       }
                       scope.documents.push(scope.selectedDoc);
                       scope.selectedChkboxCount++;
                   }else {
                       scope.selectedDoc = {
                           'contractDocumentId' : fileId,
                           'directContractDocument':true
                       }
                       scope.documents.push(scope.selectedDoc);
                       scope.selectedChkboxCount++;
                   }
               }else {
                   scope.documents = scope.documents.filter(elm => elm.contractDocumentId != fileId)
                   scope.selectedChkboxCount--;
               }
               $rootScope.documents = scope.documents;
               scope.syncCdrHeaderFromRows();
            }
            scope.$watch('documents', function() {
                $rootScope.documents = scope.documents;
            });
        },
    }
}

function  contractDocUpload($rootScope,$timeout,showPageService,documentVersioningService,formService,$http) {
            return{
                restrict: 'AE',
                templateUrl: $rootScope.createHtmlUrl("ui2.0/directiveTemplates/contractDocUpload.html"),
                link: function(scope,element,attrs,controller){
                    showPageService.toShowContractUpload = false;
                    scope.isDocsUploaded = false;
                    const draftMetaDataApiUrl = window.location.href.split(`/${envAlias}`)[0] + '/listRenderer/list/367/draftMetaData?entityTypeId=160';
                    scope.metaData = {};
                        (()=>{
                            if(_.get(scope.globalData, "pageType ") != 2 && _.get(scope.data, "entityTypeId.values") == 160){
                                $http.get(draftMetaDataApiUrl).then(function (response) {
                                    scope.metaData = response.data;
                                });
                            }
                        })();
                    scope.customId= 241473; //static buttonMapper ID
                    if(!formService.buttonMapper)
                        formService.buttonMapper = {};
                    formService.buttonMapper[scope.customId] = [{
                        "name": "Upload",
                        "label": "Upload",
                        "api": "/file/upload/draft",
                        "type": "button",
                        "properties": {
                            "buttonType": "upload",
                        },
                        "active": true
                    }]
                    scope.uploadContractDocFiles = ()=>{
                        $('.uploadFileCustomCdr').click();
                    }
                },
            }
        }

/* *************** DEPENDENCY INJECTION ARRAY OF EACH DIRECTIVE ******************/
attributeTable2.$inject = ['$rootScope','showPageService'];
draggableElem.$inject = ['$document'];
showinpopup2.$inject = ['$timeout', '$uibModal', '$rootScope','showPage2DataTransformationService','showPageService','$route','$window'];
bulkactionpopup.$inject = ['$timeout', '$uibModal', '$rootScope'];
treeViewNew.$inject = ['$rootScope'];
ajaxAutocompleteNew.$inject = ['$parse','$compile','$rootScope','showPageService','formService','dataManipulationService'];
scrollElem.$inject = ['$timeout','showPage2DataTransformationService'];
multipleSelect.$inject = ['$rootScope','$timeout'];
autoExpandTextarea.$inject = ['$timeout'];
contractToCdrTab.$inject = ['$rootScope','showPageService'];
dragAndDropFiles.$inject = ['formService'];

contractDocUpload.$inject = ['$rootScope','$timeout','showPageService','documentVersioningService','formService','$http'];
/* *************** END OF DEPENDENCY INJECTION ARRAY  ****************************/

})();
